import { deleteOffersFromList } from "@/services/mulesoft";
import { formatDay } from "@/utils/dateFormat";
import {
  useAppDispatch,
  useAppSelector,
} from "@/utils/hooks/reactUseCustomHooks";
import {
  IAvailableOffer,
  updateFavouriteOffers,
} from "@/utils/redux/favOffers";
import { FC } from "react";
import { Box, Button, Text } from "@dxp-feed/ui";
import ImageWrapper from "@/components/ImageWrapper";
import OffersCardHeader from "@/templates/offers/_components/OffersCardHeader";
import { removeHTMLTags } from "@/helpers/useCommonFunctions";
import { useGigya } from "@dxp-feed/gigya";
import { useGigyaAccountInfo } from "@/helpers/gigyaCentralSsoHook";

interface IAvailableOffersSection extends IAvailableOffer {
  trashButton?: boolean;
  deleteOffersFromStorage?: (selectedOffer: any) => void;
}

const AvailableOffersSection: FC<IAvailableOffersSection> = ({
  banner,
  created_at,
  id,
  offer_description: offerDescription,
  offer_id,
  offer_type,

  trashButton = true,
  deleteOffersFromStorage,
}) => {
  const { gigya, isLoaded } = useGigya();
  const { favOffers } = useAppSelector((state) => state.favoirateOffersSlice);
  const { uid } = useAppSelector((state) => state.gigyaslice);
  const dispatch = useAppDispatch();
  const formattedEndDate = offerDescription?.endDate
    ? formatDay(offerDescription?.endDate)
    : "";

  const gigyaToken = useGigyaAccountInfo();

  const deleteOffersFromListFunction = async () => {
    if (uid) {
      const token = await gigyaToken();
      const filterOffers =
        favOffers?.favouriteOffers?.filter(
          (offer) => offer?.offer_id !== offer_id
        ) || [];
      const updatedOffers = [...filterOffers];

      dispatch(updateFavouriteOffers(updatedOffers));
      deleteOffersFromList({
        offer_id: offer_id,
        token: token?.idToken,
      });
    } else {
      deleteOffersFromStorage && deleteOffersFromStorage(offerDescription);
    }
  };

  return (
    <Box
      key={offer_id + offer_type}
      as="div"
      className="border-b-[2px] border-grey350 px-6"
    >
      <Box as="div" className="flex items-start justify-between py-3">
        <Box as="div" className="flex items-start w-3/4">
          <Box as="div" className="min-w-[60px]">
            <ImageWrapper
              src={offerDescription?.imageName ?? "/grocerry.svg"}
              alt="Offers Image"
              width={60}
              height={40}
            />
          </Box>
          <Box as="div" className="pl-3 max-w-[295px]">
            <OffersCardHeader
              headerOffers={offerDescription}
              styleClass={"rounded-full w-[155px] h-[29px] px-4"}
            />
            <Text
              as="p"
              className="text-sm font-normal text-brandBlack pt-[4px] pb-[0px]"
              dangerouslySetInnerHTML={{
                __html:
                  removeHTMLTags(offerDescription?.description ?? "").length >
                  90
                    ? offerDescription.description.slice(0, 90) + "..."
                    : offerDescription.description || "",
              }}
            ></Text>
          </Box>
        </Box>
      </Box>
      <Box
        as="div"
        className={`flex items-center ${trashButton ? "justify-end" : "justify-start"} pb-3`}
      >
        <Box as="div" className="pl-[72px] w-3/4 left-0">
          <Text as="p" className="text-sm text-grey700 font-normal">
            Offer Expires
            <Text as="span" className="font-bold ml-[5px]">
              {formattedEndDate}
            </Text>
          </Text>
        </Box>
        {trashButton && (
          <Box as="div" className="w-1/3 flex justify-end">
            <Button variant="icon"
              onClick={deleteOffersFromListFunction}
              as="div"
              className="text-brandSecondary w-[40px] h-[40px] bg-brandWhite cursor-pointer !rounded-[40px] border-[1px] border-solid border-brandSecondary flex items-center justify-center"
            >
              <Text as="span" className="icon-trash"></Text>
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default AvailableOffersSection;
